define([
    "dojo/_base/declare",
    "csi/heading/EnumController"
], function(declare,EnumController) {

    return declare(EnumController, {
        start: function() {
        	// summary: if there are subquestions, then do not hold change to response
            var node = this.getNode();
            if (node.SubQuestions && node.SubQuestions.length) {
                this.bHold = false;
            }
            
            this.inherited(arguments);
        }
    });
});